exports.Routes = {
  ForgotPasswordPage: (query) => ({ pathname: "/forgot-password", query }),
  LoginPage: (query) => ({ pathname: "/login", query }),
  SignupPage: (query) => ({ pathname: "/signup", query }),
  Page404: (query) => ({ pathname: "/404", query }),
  AccountPage: (query) => ({ pathname: "/account", query }),
  BatchBookStep1Page: (query) => ({ pathname: "/admin/batch-registration/1", query }),
  BatchBookStep2Page: (query) => ({ pathname: "/admin/batch-registration/2", query }),
  BatchBookStep3Page: (query) => ({ pathname: "/admin/batch-registration/3", query }),
  BatchRegistrationPage: (query) => ({ pathname: "/admin/batch-registration", query }),
  DiscountsPage: (query) => ({ pathname: "/admin/discounts", query }),
  AdminShowOrderPage: (query) => ({ pathname: "/admin/orders/[orderId]", query }),
  OrdersPage: (query) => ({ pathname: "/admin/orders", query }),
  PrivateSchoolRegistrationDetailPage: (query) => ({ pathname: "/admin/private-school/[registrationId]", query }),
  PrivateSchool: (query) => ({ pathname: "/admin/private-school", query }),
  ProctorPage: (query) => ({ pathname: "/admin/proctor", query }),
  RosterPage: (query) => ({ pathname: "/admin/rosters", query }),
  BlockSchedulerPage: (query) => ({ pathname: "/admin/schedule", query }),
  AdminTestResultsPage: (query) => ({ pathname: "/admin/test-results", query }),
  AdminTestProgressPage: (query) => ({ pathname: "/admin/test-results/progress", query }),
  AdminToolsPage: (query) => ({ pathname: "/admin/tools", query }),
  BookTestingPage: (query) => ({ pathname: "/book-testing", query }),
  GroupStep1Page: (query) => ({ pathname: "/book-testing/group/[orderId]/1", query }),
  GroupStep2Page: (query) => ({ pathname: "/book-testing/group/[orderId]/2", query }),
  GroupStep3Page: (query) => ({ pathname: "/book-testing/group/[orderId]/3", query }),
  HomeschoolStep1Page: (query) => ({ pathname: "/book-testing/homeschool/[orderId]/1", query }),
  HomeschoolStep2Page: (query) => ({ pathname: "/book-testing/homeschool/[orderId]/2", query }),
  HomeschoolStep3Page: (query) => ({ pathname: "/book-testing/homeschool/[orderId]/3", query }),
  JoinGroupBookingOne: (query) => ({ pathname: "/book-testing/join-group/[groupUuid]/1", query }),
  JoinGroupBookingTwo: (query) => ({ pathname: "/book-testing/join-group/[groupUuid]/2", query }),
  JoinGroupBooking: (query) => ({ pathname: "/book-testing/join-group/[groupUuid]", query }),
  PrivateSchoolPage: (query) => ({ pathname: "/book-testing/privateschool", query }),
  CertificateGenerator: (query) => ({ pathname: "/certificate-generator", query }),
  ShowFluencyTestResultPage: (query) => ({ pathname: "/fluency-test-results/[testResultId]", query }),
  IdGenerator: (query) => ({ pathname: "/id-generator", query }),
  Home: (query) => ({ pathname: "/", query }),
  MAPFluencyPage: (query) => ({ pathname: "/map-fluency", query }),
  ReadingFluencyStep1Page: (query) => ({ pathname: "/map-fluency/1", query }),
  ReadingFluencyStep2Page: (query) => ({ pathname: "/map-fluency/2", query }),
  NewTestResultsPage: (query) => ({ pathname: "/map-testing", query }),
  OrgReportPage: (query) => ({ pathname: "/map-testing/report", query }),
  MapTestingSubscriptionsPage: (query) => ({ pathname: "/map-testing/subscriptions", query }),
  MindPrintStep1Page: (query) => ({ pathname: "/mind-print/1", query }),
  MindprintStep2Page: (query) => ({ pathname: "/mind-print/2", query }),
  MindPrintPage: (query) => ({ pathname: "/mindprint", query }),
  ShowOrderPage: (query) => ({ pathname: "/orders/[orderId]", query }),
  OrdersHistoryPage: (query) => ({ pathname: "/orders/order-history", query }),
  ReportsPage: (query) => ({ pathname: "/reports", query }),
  ProgressReportPage: (query) => ({ pathname: "/reports/progress/[studentId]", query }),
  ShowTestResultPage: (query) => ({ pathname: "/test-results/[testResultId]", query })
}